import { LeagueAgeCategory } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const leagueAgeCategoryDictionary = createSimpleDictionary([
    { id: LeagueAgeCategory.Senior, name: 'dictionaries.clAgeCategory.senior' },
    { id: LeagueAgeCategory.Youth, name: 'dictionaries.clAgeCategory.youth' },
    { id: LeagueAgeCategory.Kids, name: 'dictionaries.clAgeCategory.kids' },
]);
